export default class CoreOptions {
    constructor() {
        /**
         * If true the plugin will store the events and send them later when there's connection
         * Default: false
         */
        this.offline = false;
        /**
         * Host of the Fastdata service
         * Default: 'lma.npaw.com'
         */
        this.host = 'lma.npaw.com';
        /**
         * To disable cookies storage fallback after local/sessionstorage
         * Default: true
         */
        this.disableCookies = true;
        /**
         * To force the use of cookies storage instead of local/sessionstorage
         * Default: false
         */
        this.forceCookies = false;
        /**
         * To disable all possible storages usage (cookies, localStorage, sessionStorage)
         * CAUTION: enabling this option session tracking may stop to work properly
         * Default: false
         */
        this.disableStorage = false;
        /**
         * Define the security of NQS calls.
         * If true it will use 'https://',
         * if false it will use 'http://',
         * if null/undefined it will use '//'.
         * Default: true
         */
        this['app.https'] = true;
        /**
         * Enable get configuration from LMA periodically
         * Default: false
         */
        this['lma.refresh.configuration.enabled'] = false;
        /**
         * Time to get configuration from LMA service
         * Default: 300 (5 minutes)
         */
        this['lma.refresh.configuration.seconds'] = 300;
        /**
         * Parses fastdata response to modify the host where the requests will be sent
         * Default: undefined
         */
        this['parse.fdsResponseHost'] = null;
    }
    /**
     * Updates core options based on the received {@link AnalyticsOptions}
     * @param options AnalyticsOptions object
     */
    updateOptions(options) {
        Object.keys(this).forEach((key) => {
            if (options[key] != undefined) {
                this[key] = options[key];
            }
        });
    }
    isRefreshLMAConfigurationEnabled() {
        return this['lma.refresh.configuration.enabled'];
    }
    refreshLMAConfigurationSeconds() {
        return this['lma.refresh.configuration.seconds'];
    }
    getHost() {
        return this.host;
    }
    /**
     * Returns the FastData host
     *
     */
    getFastDataHost() {
        return this.host;
    }
}
